import styled from 'styled-components';
import Media from '../../utils/media';

/* -------------------------- RATE --------------------------- */
export const RateStyled = styled.div`
  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    max-width: ${Media.SIZE.MD}px;
    padding: 10px 15px;
  }
`;

export const RateTitleStyled = styled.div`
  font-family: SVN-GilroyMedium;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  padding-top: 70px;

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.MD';

    /* font-style: italic; */
    font-size: 30px;
    font-weight: 700;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    /* text-decoration: underline; */
  }
`;

export const RateListStyled = styled.div`
  padding-top: 70px;
  display: flex;
  flex-wrap: wrap;
  margin: 0px auto;
  width: calc(100% - 95px * 2);
  gap: 0 70px;

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';

    gap: 0 40px;
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    padding-top: 20px;
    display: flex;
    flex-wrap: wrap;
    margin: 0px auto;
    width: 100%;
    gap: unset;
  }
`;

export const RateItemStyled = styled.div`
  width: auto;
  height: auto;
  border-radius: 10px;
  background-color: #f1f1f1;
  flex: 1 1 calc(50% - 70px / 2);
  padding: 16px;
  display: flex;

  &:nth-child(n + 3) {
    margin-top: 20px;
  }

  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 68px;
    }
  }

  .comment {
    margin-left: 25px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .comment-name {
      font-family: SVN-GilroyMedium;
      font-size: 24px;
      font-weight: 700;
      text-align: left;
    }

    .comment-rate {
      margin-top: 10px;
    }

    .comment-message {
      font-family: SVN-GilroyLight;
      font-size: 20px;
      font-weight: 400;
      text-align: left;
      margin-top: 10px;
    }
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';

    /* max-width: calc((100% - 40px) / 2); */

    &:nth-child(n + 3) {
      margin-top: 20px;
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    width: 100%;
    height: max-content;
    border-radius: 10px;
    background-color: #f1f1f1;
    flex: unset;
    padding: 16px;
    display: flex;

    &:nth-child(n + 3) {
      margin-top: unset;
    }

    &:not(:first-child) {
      margin-top: 15px;
    }

    .avatar {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    .comment {
      margin-left: 15px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;

      .comment-name {
        font-family: SVN-GilroyMedium;
        font-size: 16px;
        font-weight: 700;
        text-align: left;
      }

      .comment-rate {
        margin-top: 10px;
      }

      .comment-message {
        font-family: SVN-GilroyLight;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        margin-top: 10px;
      }
    }
  }
`;
